module.exports = __webpack_public_path__ + "static/media/Spiritomb_gaussian2.32d3c562.png";